<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">International Healthcare Center</h3>
            <p class="depth">
                The International Healthcare Center at Ewha Womans University Medical Center provides comprehensive
                healthcare services in a patient-friendly environment for international patients. We have built
                long-term relationships with US Armed Forces in Korea, SOS International, Health Authority of Abu Dhabi
                and other government organizations, and medical institutions from all over the world and have gained
                valuable experience to better serve our diverse international patient care. Our medical center provides
                emergency care, ambulatory care, out-patient clinics, in-patient treatment and health promotion check-up
                programs and is dedicated to health and innovation to provide the best care for our patients and their
                families worldwide.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">Concierge Service and Coordinator Service</h3>
            <p class="depth">
                Ewha Womans University Medical Center provides care to international patients from over 60 countries.
                Our medical center employs highly educated and experienced medical staff and coordinators who speak
                English, Chinese, Russian and Arabic and provides with customized culture specific menu, concierge
                service and VIP ward for our special guests to make patient stay as comfortable as possible.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">One-Stop Fast Service</h3>
            <p class="depth">
                We understand that time is of essence for international patients. We offer convenient one-stop service
                for our patients including same day consultation and examination service. Our international healthcare
                center also provides coordinators to provide assistance with registration, accommodation reservation to
                discharge and airport transportation services.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">Hours of Operation (International Healthcare Center)</h3>
            <div class="info information-call__box">
                <div class="information-call__img"><img alt="" src="/resource/icon/phon.png">
                    <h4 class="pc-none">Weekdays : 09:00 ~ 17:00</h4>
                </div>

                <div class="information-call__text">
                    <h4 class="mo-none">Weekdays : 09:00 ~ 17:00</h4>

                    <p>
                        Saturdays : Closed <br>
                        Sundays and public holidays : Please visit the emergency center on the 1st floor
                    </p>
                </div>
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">Location (International Healthcare Center)</h3>
            <h4 class="bullet02">The International Healthcare Center is located on the 1st floor.</h4>
            <div class="layout mt20">
                <div class="layout__inner">
                    <div class="layout__info">
                        <div class="layout__store">
                            <h4 class="layout__store-tit">1F</h4>
                            <ul class="layout__store-list">
                                <!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if-->
                                <li class="layout__store-item active">
                                    <button type="button"><span>10</span>웰에이징센터</button>
                                </li><!--v-if--><!--v-if-->
                                
                            </ul>
                        </div>
                        <div class="layout__map">
                            <!-- <h3 class="tit"><span class="num">{{current.floor}}</span><span class="circle"></span></h3> -->
                            <div class="pin active" style="bottom: 27%;right:calc(9.7% - 26px)"><img
                                    src="/resource/icon/pin.svg" alt="이미지" class="active"></div><img
                                src="/displayFile.do?name=20241128.1527.25.184.jpg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>